import React, {Component} from "react";
import _ from 'lodash';

class Help extends Component {

    hideHelp = () => {
        this.props.hideHelp();
    }
    
    render() {
        const {showHelp} = this.props;
        
        return (
            showHelp ? 
            <div class="help">
                <div class="hide-scores" onClick={this.hideHelp}><i class="fas fa-times"></i></div>
                <h2><i class="fas fa-question-circle"></i> How to play</h2>
                <p>Try to guess the word, you have 6 chances to get it right.</p>
                <p>The colours of the squares will change once you submit your answer with the "ENTER" key to signify how close you were.</p>
                <ul>
                    <li><span class="help__green">This colour tile</span> the letter was correct, and in the correct position.</li>
                    <li><span class="help__orange">This colour tile</span> the letter is present in the word, but not in the correct position.</li>
                    <li><span class="help__grey">This colour tile</span> that letter is not in the word at all.</li>
                </ul>
                <p>Once you've successfully found the word, you can press NEXT WORD to carry on, or share so you can challenge your friends.</p>
                <p>Press the <i class="fas fa-trophy"></i> trophy in the top left for detailed stats, new themes and a break down of every word you've solved.</p>
                <hr/>
                <p>
                    Have feedback for us?<br/>
                    <a href="https://forms.gle/NSescnH2J1VfQn949" target="_blank">Click here to let us know.</a>
                </p>
                <p>
                    Found a word that isn't in the word list but really should be?<br/>
                    <a href="https://forms.gle/pBqjBtHyAJkzBhMR8" target="_blank">Click here to suggest it.</a>
                </p>
                <p>
                    Found a bug? Please do report it:<br/>
                    <a href="https://forms.gle/f6JJJ6PX2vkw7Gaa9" target="_blank">Click here to report it.</a>
                </p>
            </div>
            : <></>
        );
    }
}

export default Help;